import { useSelector } from 'react-redux';
import LeftLogo from './LeftLogo/LeftLogo';
import RightLogo from './RightLogo/RightLogo';
import SubTitle from './SubTitle/SubTitle';
import SupTitle from './SupTitle/SupTitle';
import Title from './Title/Title';

function Header({ preview }) {
  const header = useSelector((state) => state.certificate.header);
  const HeaderStyle = {
    display: 'flex'
  };
  return (
    <div style={HeaderStyle}>
      <div>
        <LeftLogo headerState={header} preview={preview} />
      </div>
      <div style={{ margin: '0 1.5rem', flex: '1' }}>
        <div>
          <SupTitle headerState={header} preview={preview} />
          <Title headerState={header} preview={preview} />
          <SubTitle headerState={header} preview={preview} />
        </div>
      </div>
      <div>
        <RightLogo headerState={header} preview={preview} />
      </div>
    </div>
  );
}

export default Header;
